/**
 * Constants for Set Organization Structure page.
 * Single source of truth: query scope, copy, validation, layout, and error messages.
 * Open/Closed: add new copy or reasons here without changing components.
 */

export const QUERY_SCOPE = 'organization-structure';

export const PAGE_COPY = {
  TITLE: 'Set up your Organization Structure',
  LOCATIONS_HEADING: 'Areas',
  ADD_FACILITY: 'Add New Facility',
};

export const DISABLED_REASONS = {
  NO_FACILITIES: 'Add at least one facility to continue',
  NO_LOCATIONS: 'Add at least one area to any facility to continue',
};

export const WIZARD_STEP = {
  CURRENT: 1,
  TOTAL: 3,
  NAME: 'Organization Structure',
};

/** Shared panel card styles for facilities and locations columns */
export const PANEL_CARD_CLASS =
  'bg-white rounded-[20px] border border-[#d3d6dc] shadow-[0px_2px_10px_0px_rgba(0,0,0,0.15)]';

/** User-facing error messages for facility actions (single source of truth) */
export const ERROR_MESSAGES = {
  ADD_FACILITY: 'Failed to create facility. Please try again',
  UPDATE_FACILITY: 'Failed to update facility. Please try again',
  DELETE_FACILITY: 'Failed to delete facility. Please try again',
  DUPLICATE_FACILITY: 'Failed to duplicate facility. Please try again',
};

/**
 * Build duplicate facility options for the service call.
 * Single place for options so UI and API stay in sync.
 * @param {string} newName - Trimmed name for the duplicated facility
 * @returns {Object} Options for duplicateFacility service
 */
export function buildDuplicateFacilityOptions(newName) {
  return {
    newName: (newName || '').trim(),
    includeLocations: true,
    includeFacilityStandards: true,
    includeLocationStandards: true,
  };
}
